import React from 'react';
import { reactSelectComponents } from '@yola/ws-ui';

const Input = (props) => (
  <reactSelectComponents.Input
    {...props}
    isHidden={false}
    className="ws-color-scheme-select__input"
  />
);

export default Input;
